module.exports = __webpack_public_path__ + "media/svg-new/avatar-21 1-e96ec50a.svg";